<script setup lang="ts">
interface Props {
  items: string[]
  modelValue: string
  size?: 'sm' | 'md'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md'
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const sizes = {
  sm: 'text-xs px-4 py-1.5',
  md: 'text-sm px-5 py-2'
}
</script>

<template>
  <div class="inline-flex items-center gap-1 p-1 bg-oxo-card-bg/50 rounded-lg border border-oxo-border">
    <button
      v-for="item in items"
      :key="item"
      @click="emit('update:modelValue', item)"
      class="relative font-bold transition-all duration-300 rounded-md focus:outline-hidden focus-visible:ring-2 focus-visible:ring-oxo-red"
      :class="[
        sizes[size],
        modelValue === item 
          ? 'bg-oxo-red text-white shadow-md' 
          : 'text-foreground-dim hover:text-foreground hover:bg-background/50'
      ]"
      type="button"
    >
      <slot name="item" :item="item">
        {{ item }}
      </slot>
    </button>
  </div>
</template>
